/**
 * Date locale au format `YYYY-MM-DD` (celui des `el-date-picker` en `value-format="YYYY-MM-DD"`).
 *
 * `new Date().toISOString().split('T')[0]` donne la date UTC : entre minuit et 2 h (heure de Paris), c'est la veille.
 */
export function toLocalIsoDate(date: Date = new Date()): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** Partie date (`YYYY-MM-DD`) d'une date de l'API (`2026-09-22T00:00:00`), sans conversion de fuseau. */
export function isoDatePart(value: string | null | undefined): string {
  return value ? value.slice(0, 10) : ''
}

/**
 * Date-heure enregistrée à l'heure de Paris (registres de la méthode, réunions) : l'API la rend avec un « Z »
 * (sérialisation UTC de KStone) alors qu'elle n'est pas en UTC. Lue sans conversion de fuseau, ou null.
 */
export function parisDateTime(value: string | null | undefined): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/.exec(value ?? '')
  if (!match) return null
  const [, y, mo, d, h, mi, s] = match
  return new Date(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi), Number(s ?? 0))
}

/** « 2026-10-24T10:49:16Z » (heure de Paris) → « 24/10/2026 10:49 », sans conversion de fuseau ; vide sinon. */
export function formatParisDateTime(value: string | null | undefined): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value ?? '')
  return match ? `${match[3]}/${match[2]}/${match[1]} ${match[4]}:${match[5]}` : ''
}

/** Date sans heure de l'API (« 2026-10-03T00:00:00Z ») → « 03/10/2026 », sans conversion de fuseau ; vide sinon. */
export function formatIsoDate(value: string | null | undefined): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '')
  return match ? `${match[3]}/${match[2]}/${match[1]}` : ''
}
